import ProfilerAnswerError from './ProfilerAnswerError';
class ChoiceIdRequired extends ProfilerAnswerError {
    constructor(options) {
        super('The answer is not among the allowed options', options);
    }
}
export default ChoiceIdRequired;
